/**
 * Returns a Promise that will return in some number of milliseconds
 * @param milliseconds The number of milliseconds to sleep
 */
export const sleep = (milliseconds: number): Promise<number> =>
    new Promise<number>((resolve) => setTimeout(() => resolve(milliseconds), milliseconds));
